import { FormDefinition } from "../../Components/Form/Form";
import { boolean_selection_validator, selection_validator } from "../formFieldValidators";


export const needHelpWithDefinition: FormDefinition = {
  seekingEducation: {
    frLabel: "Pour cette demande, je souhaite obtenir une éducation générale en PI (p. ex. Par où commencer? Qu'est-ce qu'un brevet?, etc.)",
    label: "At this time, for this application, I'm seeking General IP Education (e.g. where do I start? What is a patent?, etc.)",
    inputType: "boolean",
    validator: boolean_selection_validator
  },
  businessGoal: {
    frLabel: "Pour cette demande, j'aimerais rencontrer un conseiller en PI pour obtenir des conseils sur la façon d'aligner ma stratégie de PI avec ma stratégie et mes objectifs d'affaires.",
    label: "At this time, for this application, I'd like to meet with an IP Advisor for coaching on how to align my IP strategy with my business strategy/goals",
    inputType: "boolean",
    validator: boolean_selection_validator
  },
  agreementSigned: {
    frLabel: "Avez-vous, vous et vos cofondateurs, signé un « accord de cession de PI des cofondateurs » qui attribue la PI à la société?",
    label: 'Have you and your cofounders signed a "Co-founders IP assignment agreement" that assigns IP to the corporation?',
    inputType: "dropdownSelect",
    validator: selection_validator,
    additionalData: {
      selectionData: [
        { value: "yes", text: "Yes", frText: "Oui" },
        { value: "no", text: "No", frText: "Non" },
        { value: "noCofounder", text: "No Co-founder", frText: "Pas de cofondateur" },
      ]
    }
  },
  desiredActivities: {
    label: "At this time, for this application, I'd like help covering IP Service Provider costs for the following activities:",
    frLabel: "Pour cette demande, j'aimerais de l'aide pour couvrir les coûts d'un fournisseur de services en PI pour les activités suivantes :",
    inputType: "multiSelect",
    validator: selection_validator,
    additionalData: {
      selectionData: [
        { value: "IP Strategy", text: "IP Strategy", frText: "Stratégie de PI" },
        { value: "Invention/Patent Mining", text: "Invention/Patent Mining", frText: "Exploration d'inventions/brevets" },
        { value: "Patentability/Novelty/Prior Art Search", text: "Patentability/Novelty/Prior Art Search", frText: "Recherche de brevetabilité/nouveauté/art antérieur" },
        { value: "Patent Landscape Report", text: "Patent Landscape Report", frText: "Rapport sur le paysage des brevets" },
        { value: "Trademark Clearance Search", text: "Trademark Clearance Search", frText: "Recherche de disponibilité de marque" },
        { value: "Trade Secret Protection Plan", text: "Trade Secret Protection Plan", frText: "Plan de protection des secrets commerciaux" },
        { value: "Patent Filing", text: "Patent Filing", frText: "Dépôt de brevet" },
        { value: "Patent Conversion", text: "Patent Conversion", frText: "Conversion de brevet" },
        { value: "Patent Prosecution", text: "Patent Prosecution", frText: "Poursuite de brevet" },
        { value: "Trademark Filing", text: "Trademark Filing", frText: "Dépôt de marque" },
        { value: "Licensing Agreement Review/Drafting", text: "Licensing Agreement Review/Drafting", frText: "Révision/rédaction d'accord de licence" },
        { value: "Design Patent/Industrial Design Application", text: "Design Patent/Industrial Design Application", frText: "Demande de brevet de design/dessin industriel" },
        { value: "Other", text: "Other", frText: "Autre" }
      ]
    },
  },
  workingWithFirm: {
    label: "Is your company currently working with an IP Service Provider that you intend to use for the support being sought from the Elevate IP program?",
    frLabel: "Votre entreprise travaille-t-elle actuellement avec un fournisseur de services en PI que vous prévoyez utiliser pour le soutien demandé dans le cadre du programme ÉleverlaPI?",
    inputType: "boolean",
    validator: boolean_selection_validator
  },
  govtSupport: {
    label: "Has your company ever received government funded support related to Intellectual Property?",
    frLabel: "Votre entreprise a-t-elle déjà reçu un soutien financé par le gouvernement lié à la propriété intellectuelle?",
    inputType: "boolean",
    validator: boolean_selection_validator
  },
}
